import { useContext, useEffect, useCallback, useState } from 'react'
import {
    UNSAFE_NavigationContext as NavigationContext,
} from 'react-router-dom'


//Este hook permite bloquear la navegación interna de la aplicación y reintentar cambiar la navegacion solo si se confirma
//esto es util en caso de necesitar un modal de confirmacion antes de salir de un módulo
export function useBlocker(blocker, when = true) {
    const navigator = useContext(NavigationContext).navigator
    useEffect(() => {
        if (!when) return

        const unblock = navigator.block((tx) => {
            const autoUnblockingTx = {
                ...tx,
                retry() {
                    unblock()
                    tx.retry()
                }
            }
            blocker(autoUnblockingTx)
        })

        return unblock
    }, [navigator, blocker, when])
}

// useNavigationPrompt.ts

export function useNavigationPrompt(when) {
    const [showPrompt, setShowPrompt] = useState(false)
    const [lastTx, setLastTx] = useState(null)

    const blocker = useCallback(
        (tx) => {
            setShowPrompt(true)
            setLastTx(tx)
        },
        []
    )

    const confirmNavigation = () => {
        setShowPrompt(false)
        if (lastTx) {
            lastTx.retry()
        }
    }

    const cancelNavigation = () => {
        setShowPrompt(false)
        setLastTx(null)
    }

    useBlocker(blocker, when)

    return {
        showPrompt,
        confirmNavigation,
        cancelNavigation
    }
}
